(function () {
    'use strict';

    angular.module('inoApp').directive('loadingIndicator', ['$rootScope', function ($rootScope) {
        var directive = {
            restrict: "E",
            replace: false,
            scope: {
                busyConfig: '=',
            },
            link: link,
            template: '<div cg-busy="busyConfig"></div>'
        };

        return directive;

        function link(scope, element) {
            /* DOM manipulation */
            var body = document.body;
            element.detach();
            angular.element(body).append(element);
        }
    }]);

})();